export const FOOTER_TARGET_SELF_ROUTES = ['registration', 'contact']
